function CancelCircle({ size = 58, fill = "#EB5757" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.5153 8.48567C38.2 -2.82725 19.7981 -2.82725 8.48282 8.48567C-2.82761 19.7986 -2.82761 38.2052 8.48282 49.5181C14.1405 55.1734 21.5703 57.9998 29.0003 57.9998C36.4303 57.9998 43.8577 55.1733 49.5153 49.5181C60.8282 38.2053 60.8282 19.7986 49.5153 8.48567ZM40.9659 37.55C41.9113 38.4954 41.9113 40.0234 40.9659 40.9688C40.4945 41.4402 39.8755 41.6772 39.2565 41.6772C38.6376 41.6772 38.0186 41.4402 37.5471 40.9688L29.0002 32.4194L20.4557 40.9663C19.9818 41.4377 19.3628 41.6747 18.7463 41.6747C18.1273 41.6747 17.5083 41.4377 17.0368 40.9663C16.0915 40.021 16.0915 38.4905 17.0368 37.5475L25.5814 29.0007L17.0345 20.4538C16.0891 19.5085 16.0891 17.978 17.0345 17.035C17.9774 16.0897 19.5079 16.0897 20.4532 17.035L29.0001 25.5819L37.547 17.035C38.4923 16.0897 40.0204 16.0897 40.9657 17.035C41.911 17.978 41.911 19.5085 40.9657 20.4538L32.4188 29.0007L40.9659 37.55Z"
        fill={fill}
      />
    </svg>
  );
}

export default CancelCircle;
